import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "../Button";

import { faScissors } from "@fortawesome/free-solid-svg-icons";
import { useRoot } from "../../contexts/Root";

export const ClipButton = () => {
  const { setClippingEnabled, clippingEnabled } = useRoot();

  const toggle = () => {
    if (setClippingEnabled !== undefined) {
      setClippingEnabled(!clippingEnabled);
    }
  };

  const style = {
    height: 25,
  };

  return (
    <Button onClick={toggle} emphasize={clippingEnabled}>
      <FontAwesomeIcon style={style} icon={faScissors} />
    </Button>
  );
};
